import { For, type JSX, Show } from 'solid-js';
import { t, tPlural } from '../i18n';
import type { RepoBulkAnswer } from '../lib/repo-enablement';
import { count } from '../lib/time';

// What a bulk answer skipped. The refusal sentences are the API's own `detail`: it is the arbiter,
// and it names the way out.

export function RepoEnablementRefusals(props: { readonly answer: RepoBulkAnswer }): JSX.Element {
  return (
    <>
      <Show when={props.answer.unchanged > 0}>
        <p class="repo-enablement__line">
          {tPlural('repo_enablement.unchanged', props.answer.unchanged, {
            shown: count(props.answer.unchanged),
          })}
        </p>
      </Show>
      <Show when={props.answer.recipe_not_applied > 0}>
        <p class="repo-enablement__line">
          {tPlural('repo_enablement.recipe_not_applied', props.answer.recipe_not_applied, {
            shown: count(props.answer.recipe_not_applied),
          })}
        </p>
      </Show>
      <Show when={props.answer.refused.length > 0}>
        <ul class="repo-enablement__refused">
          <For each={props.answer.refused}>
            {(row) => (
              <li>
                {t('repo_enablement.refused_line', { n: count(row.count), detail: row.detail })}
              </li>
            )}
          </For>
        </ul>
      </Show>
    </>
  );
}
